// src/components/tables/AncillaryTable.tsx
import React from "react";
import EntityTable from "../EntityTable";
import {
  anchorConnectionColumnId,
  renderRowUpdateAction,
} from "../../common/TableUtils";
import { ConnectionFormDataController } from "../../controllers/formController";
import { Work } from "../../types/work";
import {
  AncillaryConnection,
  AncillaryConnectionFilters,
} from "../../types/ancillary";
import {
  ancillaryColumns,
  ancillaryFilterSpec,
} from "../../common/entities/AncillaryUtils";
import useAncillaryQuery from "../../hooks/query/connections/useAncillaryQuery";
import AncillaryDialog from "../modals/Ancillary/AncillaryDialog";
import useServerFilters from "../../hooks/useServerFilters";

interface AncillaryTableProps {
  columns?: typeof ancillaryColumns;
  filters?: Partial<AncillaryConnectionFilters>;
  systemLanguageType: Work["system_language_type"];
  controller: ConnectionFormDataController<AncillaryConnection, Work, Work>;
}

const AncillaryTable: React.FC<AncillaryTableProps> = ({
  columns = ancillaryColumns,
  controller,
  filters = {},
  systemLanguageType,
}) => {
  const {
    serverFilters,
    entityTableFilterProps,
    pagination,
    setPagination,
  } = useServerFilters(filters, ancillaryFilterSpec);
  const { useFetchConnectedEdges } = useAncillaryQuery();
  const { anchorEntity, direction, openEditDialog } = controller;

  const { data, isLoading, errorMessage } = useFetchConnectedEdges(
    anchorEntity._id,
    direction,
    {
      bodyParams: serverFilters,
      externalPagination: pagination,
      externalSetPagination: setPagination,
    }
  );

  const renderRowActions = renderRowUpdateAction<AncillaryConnection>((row) =>
    openEditDialog(row._key)
  );

  return (
    <>
      <EntityTable
        loading={isLoading}
        error={errorMessage}
        columns={columns}
        hiddenColumnIds={[anchorConnectionColumnId(direction)]}
        renderRowActions={renderRowActions}
        enableRowActions
        data={data?.data || []}
        pagination={pagination}
        manualPagination
        onPaginationChange={setPagination}
        totalRowCount={data?.total || 0}
        manualFiltering
      {...entityTableFilterProps}
      />
      <AncillaryDialog
        controller={controller}
        systemLanguageType={systemLanguageType}
      />
    </>
  );
};

export default AncillaryTable;
